export const EMBED_ROOT_ATTRIBUTE = "data-magic-comment-embed-root";
export const EMBED_MARKER_ATTRIBUTE = "data-magic-comment-embed-marker";
export const EMBED_STYLE_ID = "magic-comment-embed-styles";

export const embedStyles = `
[${EMBED_ROOT_ATTRIBUTE}] {
  position: fixed;
  inset: 0;
  z-index: 2147483646;
  pointer-events: none;
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #2D2C2B;
}

[${EMBED_ROOT_ATTRIBUTE}] * {
  box-sizing: border-box;
}

[${EMBED_ROOT_ATTRIBUTE}] [hidden] {
  display: none !important;
}

.magic-comment-embed-toolbar,
.magic-comment-embed-toolbar-toggle,
.magic-comment-embed-popup,
.magic-comment-embed-comments,
.magic-comment-embed-status,
.magic-comment-embed-marker,
.magic-comment-embed-cursor,
.magic-comment-embed-presence-bar,
.magic-comment-embed-follow-indicator {
  pointer-events: auto;
}

.magic-comment-embed-highlight {
  position: fixed;
  border: 2px solid rgba(255, 115, 0, 0.95);
  border-radius: 12px;
  background: rgba(255, 115, 0, 0.08);
  box-shadow: 0 0 0 9999px rgba(45, 44, 43, 0.05);
}

.magic-comment-embed-layer {
  position: fixed;
  inset: 0;
  pointer-events: none;
}

.magic-comment-embed-toolbar {
  position: fixed;
  right: 18px;
  bottom: 78px;
  display: none;
  gap: 8px;
  padding: 10px;
  border-radius: 16px;
  background: rgba(45, 44, 43, 0.96);
  box-shadow: 0 18px 42px rgba(45, 44, 43, 0.24);
  max-width: calc(100vw - 36px);
}

.magic-comment-embed-toolbar[data-expanded="true"] {
  display: flex;
}

.magic-comment-embed-toolbar-toggle {
  position: fixed;
  right: 18px;
  bottom: 18px;
  width: 48px;
  height: 48px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: rgba(45, 44, 43, 0.96);
  color: #f8fafc;
  cursor: grab;
  box-shadow: 0 18px 42px rgba(45, 44, 43, 0.24);
  touch-action: none;
  user-select: none;
}

.magic-comment-embed-toolbar-toggle[data-dragging="true"] {
  cursor: grabbing;
}

.magic-comment-embed-toolbar-toggle[data-corner="bottom-left"] {
  left: 18px;
  right: auto;
  bottom: 18px;
  top: auto;
}

.magic-comment-embed-toolbar-toggle[data-corner="top-right"] {
  right: 18px;
  left: auto;
  top: 18px;
  bottom: auto;
}

.magic-comment-embed-toolbar-toggle[data-corner="top-left"] {
  left: 18px;
  right: auto;
  top: 18px;
  bottom: auto;
}

.magic-comment-embed-toolbar[data-corner="bottom-left"] {
  left: 18px;
  right: auto;
  bottom: 78px;
  top: auto;
}

.magic-comment-embed-toolbar[data-corner="top-right"] {
  right: 18px;
  left: auto;
  top: 78px;
  bottom: auto;
}

.magic-comment-embed-toolbar[data-corner="top-left"] {
  left: 18px;
  right: auto;
  top: 78px;
  bottom: auto;
}

.magic-comment-embed-status[data-corner="bottom-left"] {
  left: 18px;
  right: auto;
  bottom: 84px;
  top: auto;
}

.magic-comment-embed-status[data-corner="top-right"] {
  right: 18px;
  left: auto;
  top: 84px;
  bottom: auto;
}

.magic-comment-embed-status[data-corner="top-left"] {
  left: 18px;
  right: auto;
  top: 84px;
  bottom: auto;
}

.magic-comment-embed-comments[data-corner="bottom-left"] {
  left: 18px;
  right: auto;
  bottom: 84px;
  top: auto;
}

.magic-comment-embed-comments[data-corner="top-right"] {
  right: 18px;
  left: auto;
  top: 84px;
  bottom: auto;
}

.magic-comment-embed-comments[data-corner="top-left"] {
  left: 18px;
  right: auto;
  top: 84px;
  bottom: auto;
}

.magic-comment-embed-toolbar-toggle[data-expanded="true"] {
  background: #ff7300;
}

.magic-comment-embed-toolbar-toggle-icon[data-icon="close"] {
  display: none;
}

.magic-comment-embed-toolbar-toggle[data-expanded="true"] .magic-comment-embed-toolbar-toggle-icon[data-icon="open"] {
  display: none;
}

.magic-comment-embed-toolbar-toggle[data-expanded="true"] .magic-comment-embed-toolbar-toggle-icon[data-icon="close"] {
  display: inline;
}

@media (max-width: 640px) {
  .magic-comment-embed-toolbar {
    padding: 8px;
    border-radius: 14px;
  }
}

.magic-comment-embed-marker,
.magic-comment-embed-popup-button,
.magic-comment-embed-input,
.magic-comment-embed-textarea {
  appearance: none;
  border: 0;
  pointer-events: auto;
  font: inherit;
}

/* Compact icon buttons in the floating toolbar (Annotate / Comments). */
.magic-comment-embed-icon-toolbar-button {
  appearance: none;
  border: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  color: #f8fafc;
  cursor: pointer;
  pointer-events: auto;
  padding: 0;
}

.magic-comment-embed-icon-toolbar-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.magic-comment-embed-icon-toolbar-button[data-active="true"] {
  background: #ff7300;
}

/* Icon + label toolbar button (Annotate). */
.magic-comment-embed-label-toolbar-button {
  appearance: none;
  border: 0;
  height: 36px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 0 12px 0 10px;
  background: rgba(255, 255, 255, 0.1);
  color: #f8fafc;
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: auto;
}

.magic-comment-embed-label-toolbar-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.magic-comment-embed-label-toolbar-button[data-active="true"] {
  background: #ff7300;
}

.magic-comment-embed-status {
  position: fixed;
  right: 18px;
  bottom: 84px;
  max-width: 320px;
  border-radius: 12px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 16px 34px rgba(45, 44, 43, 0.15);
  font-size: 12px;
  line-height: 1.4;
}

.magic-comment-embed-status-connected {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: auto;
  max-width: none;
  padding: 8px 10px;
  border-radius: 999px;
  font-weight: 700;
}

.magic-comment-embed-status-logo {
  width: 20px;
  height: 20px;
  border-radius: 7px;
  box-shadow: 0 1px 3px rgba(45, 44, 43, 0.14);
}

.magic-comment-embed-comments {
  position: fixed;
  right: 18px;
  bottom: 84px;
  width: min(380px, calc(100vw - 24px));
  max-height: min(520px, calc(100vh - 140px));
  overflow: hidden;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 18px 42px rgba(45, 44, 43, 0.22);
  padding: 14px;
}

.magic-comment-embed-comments-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.magic-comment-embed-scope {
  display: inline-flex;
  flex: none;
  padding: 3px;
  border-radius: 12px;
  background: rgba(148, 163, 184, 0.16);
  gap: 2px;
}

.magic-comment-embed-scope-button {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 5px 11px;
  border-radius: 10px;
  cursor: pointer;
  pointer-events: auto;
  font: inherit;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  white-space: nowrap;
}

.magic-comment-embed-scope-button:hover {
  color: #2D2C2B;
}

.magic-comment-embed-scope-button[data-active="true"] {
  background: #fff;
  color: #2D2C2B;
  box-shadow: 0 1px 2px rgba(45, 44, 43, 0.12);
}

.magic-comment-embed-comments-list {
  max-height: 380px;
  overflow: auto;
  margin-top: 12px;
  padding-right: 4px;
}

.magic-comment-embed-comments-empty {
  margin: 12px 0 0;
  color: #64748b;
  font-size: 13px;
  line-height: 1.5;
}

/* Settings row pinned at the bottom of the comments popover. */
.magic-comment-embed-comments-settings {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

.magic-comment-embed-settings-toggles {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.magic-comment-embed-toggle {
  appearance: none;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(148, 163, 184, 0.12);
  color: #475569;
  border-radius: 10px;
  padding: 6px 10px;
  font: inherit;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: auto;
}

.magic-comment-embed-toggle:hover {
  color: #2D2C2B;
}

.magic-comment-embed-toggle[data-active="true"] {
  background: #ff7300;
  border-color: #ff7300;
  color: #fff;
}

.magic-comment-embed-clear {
  appearance: none;
  border: 0;
  background: transparent;
  color: #b91c1c;
  border-radius: 10px;
  padding: 6px 8px;
  font: inherit;
  font-size: 11.5px;
  font-weight: 600;
  cursor: pointer;
  pointer-events: auto;
}

.magic-comment-embed-clear:hover {
  background: rgba(220, 38, 38, 0.1);
}

.magic-comment-embed-comments-item {
  width: 100%;
  margin-top: 10px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #fff;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;
}

.magic-comment-embed-comments-item:first-child {
  margin-top: 0;
}

.magic-comment-embed-comments-item[data-status="managed"] {
  background: rgba(245, 158, 11, 0.08);
}

.magic-comment-embed-comments-item[data-status="resolved"] {
  background: rgba(22, 163, 74, 0.06);
}

.magic-comment-embed-comments-item-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.magic-comment-embed-comments-item-number {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ff7300;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.magic-comment-embed-comments-item-author {
  font-size: 11px;
  font-weight: 600;
  color: #2D2C2B;
}

.magic-comment-embed-comments-item-status {
  margin-left: auto;
  border-radius: 999px;
  background: rgba(255, 115, 0, 0.12);
  padding: 2px 8px;
  color: #c2410c;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.magic-comment-embed-comments-item[data-status="managed"] .magic-comment-embed-comments-item-status {
  background: rgba(245, 158, 11, 0.16);
  color: #92400e;
}

.magic-comment-embed-comments-item[data-status="resolved"] .magic-comment-embed-comments-item-status {
  background: rgba(22, 163, 74, 0.14);
  color: #166534;
}

.magic-comment-embed-comments-item-text {
  margin: 8px 0 0;
  color: #2D2C2B;
  font-size: 13px;
  line-height: 1.45;
}

.magic-comment-embed-comments-item-page {
  display: inline-block;
  margin-top: 8px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.16);
  padding: 2px 8px;
  color: #475569;
  font-size: 10px;
  font-weight: 600;
}

.magic-comment-embed-comments-item-page[data-here="true"] {
  background: rgba(255, 115, 0, 0.12);
  color: #c2410c;
}

.magic-comment-embed-marker {
  position: fixed;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: #ff7300;
  color: #fff;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 12px 28px rgba(255, 115, 0, 0.28);
}

.magic-comment-embed-marker[data-status="managed"] {
  background: #f59e0b;
  box-shadow: 0 12px 28px rgba(245, 158, 11, 0.28);
}

.magic-comment-embed-marker[data-status="resolved"] {
  background: #16a34a;
}

.magic-comment-embed-popup {
  position: fixed;
  inset: auto;
  margin: 0;
  border: 0;
  max-width: none;
  max-height: none;
  width: min(380px, calc(100vw - 24px));
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.98);
  color: #2D2C2B;
  box-shadow: 0 18px 42px rgba(45, 44, 43, 0.22);
  padding: 14px;
  overflow: visible;
}

/* Rendered as a top-layer <dialog> so host modals with focus traps can't
   steal focus from the composer. Keep the backdrop invisible so the page
   stays visible behind the popup. */
.magic-comment-embed-popup::backdrop {
  background: transparent;
}

.magic-comment-embed-popup-header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.magic-comment-embed-popup-header h3 {
  margin: 0;
  flex: 1;
  font-size: 14px;
  font-weight: 700;
}

.magic-comment-embed-popup-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.magic-comment-embed-icon-button {
  appearance: none;
  border: 0;
  background: transparent;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #475569;
  cursor: pointer;
  pointer-events: auto;
  padding: 0;
}

.magic-comment-embed-icon-button:hover {
  background: rgba(45, 44, 43, 0.06);
  color: #2D2C2B;
}

.magic-comment-embed-icon-button[data-active="true"] {
  background: rgba(255, 115, 0, 0.14);
  color: #c2410c;
}

.magic-comment-embed-icon-button[data-danger="true"]:hover {
  background: rgba(220, 38, 38, 0.1);
  color: #b91c1c;
}

.magic-comment-embed-info-wrapper {
  position: relative;
}

.magic-comment-embed-info-popover {
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  width: min(320px, calc(100vw - 48px));
  max-height: 220px;
  overflow: auto;
  background: #2D2C2B;
  color: #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 11px;
  line-height: 1.5;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  box-shadow: 0 16px 30px rgba(45, 44, 43, 0.25);
  word-break: break-word;
  z-index: 1;
}

.magic-comment-embed-info-popover[hidden] {
  display: none !important;
}

.magic-comment-embed-status-bar {
  display: inline-flex;
  margin-top: 10px;
  padding: 3px;
  border-radius: 12px;
  background: rgba(148, 163, 184, 0.16);
  gap: 2px;
}

.magic-comment-embed-status-pill {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 5px 11px;
  border-radius: 10px;
  cursor: pointer;
  pointer-events: auto;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
  font-family: inherit;
}

.magic-comment-embed-status-pill:hover {
  color: #2D2C2B;
}

.magic-comment-embed-status-pill[data-active="true"] {
  background: #fff;
  color: #2D2C2B;
  box-shadow: 0 1px 2px rgba(45, 44, 43, 0.12);
}

.magic-comment-embed-status-pill[data-status="managed"][data-active="true"] {
  color: #92400e;
}

.magic-comment-embed-status-pill[data-status="resolved"][data-active="true"] {
  color: #166534;
}

.magic-comment-embed-thread-item {
  position: relative;
}

.magic-comment-embed-thread-item-row {
  display: block;
}

.magic-comment-embed-thread-item-body {
  min-width: 0;
}

.magic-comment-embed-thread-actions {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  gap: 2px;
  padding: 2px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(4px);
}

.magic-comment-embed-thread-item:hover .magic-comment-embed-thread-actions,
.magic-comment-embed-thread-item:focus-within .magic-comment-embed-thread-actions {
  display: inline-flex;
}

.magic-comment-embed-icon-button[data-size="sm"] {
  width: 24px;
  height: 24px;
  border-radius: 6px;
}

.magic-comment-embed-thread-edited {
  margin-left: 6px;
  color: #94a3b8;
  font-style: italic;
}

.magic-comment-embed-thread-edit {
  margin-top: 6px;
}

.magic-comment-embed-thread-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 6px;
}

.magic-comment-embed-thread-confirm {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding: 8px 10px;
  border-radius: 10px;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.25);
  font-size: 12px;
  color: #7f1d1d;
}

.magic-comment-embed-thread-confirm-message {
  flex: 1;
  line-height: 1.4;
}

.magic-comment-embed-thread-confirm-actions {
  display: flex;
  gap: 6px;
}

.magic-comment-embed-reply {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.18);
}

.magic-comment-embed-reply-actions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  margin-top: 8px;
}

.magic-comment-embed-popup-button[data-size="sm"] {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 10px;
}

.magic-comment-embed-popup-button[data-variant="ghost"] {
  background: transparent;
  color: #475569;
}

.magic-comment-embed-popup-button[data-variant="ghost"]:hover {
  background: rgba(45, 44, 43, 0.06);
  color: #2D2C2B;
}

.magic-comment-embed-popup-button:disabled {
  opacity: 0.48;
  cursor: not-allowed;
}

/* Scoped to [open] so the author display value doesn't override the UA
   "dialog:not([open]) { display: none }" rule and leave the overlay stuck
   on screen while closed. */
.magic-comment-embed-name-prompt[open] {
  position: fixed;
  inset: 0;
  margin: 0;
  border: 0;
  max-width: none;
  max-height: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(45, 44, 43, 0.42);
  color: #2D2C2B;
  pointer-events: auto;
}

/* Same top-layer <dialog> treatment as the composer so the identity form is
   focusable even when the host page has an open modal with a focus trap. */
.magic-comment-embed-name-prompt::backdrop {
  background: transparent;
}

.magic-comment-embed-name-card {
  width: min(420px, calc(100vw - 24px));
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.99);
  box-shadow: 0 24px 50px rgba(45, 44, 43, 0.24);
  padding: 18px;
}

.magic-comment-embed-name-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.magic-comment-embed-name-brand {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #2D2C2B;
  font-size: 13px;
  font-weight: 700;
}

.magic-comment-embed-name-brand-logo {
  width: 24px;
  height: 24px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(45, 44, 43, 0.14);
}

.magic-comment-embed-name-card h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
}

.magic-comment-embed-name-copy {
  margin: 8px 0 0;
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
}

.magic-comment-embed-popup h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
}

.magic-comment-embed-meta {
  margin-top: 6px;
  font-size: 12px;
  line-height: 1.45;
  color: #475569;
}

.magic-comment-embed-thread {
  max-height: 220px;
  overflow: auto;
  margin-top: 10px;
  padding-right: 6px;
}

.magic-comment-embed-thread-item {
  padding: 8px 0;
  border-top: 1px solid rgba(148, 163, 184, 0.16);
}

.magic-comment-embed-thread-item:first-child {
  border-top: 0;
  padding-top: 0;
}

.magic-comment-embed-thread-author {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #64748b;
}

.magic-comment-embed-thread-dot {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.magic-comment-embed-thread-avatar {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  object-fit: cover;
  flex: none;
  display: inline-block;
}

.magic-comment-embed-thread-text {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 1.45;
}

.magic-comment-embed-textarea,
.magic-comment-embed-input {
  width: 100%;
  margin-top: 10px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  border-radius: 12px;
  padding: 10px 12px;
  background: #fff;
  color: #2D2C2B;
}

.magic-comment-embed-name-input-wrap {
  position: relative;
}

.magic-comment-embed-name-input-wrap .magic-comment-embed-input {
  padding-right: 58px;
}

.magic-comment-embed-name-avatar-button {
  position: absolute;
  right: 7px;
  top: 17px;
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 30px;
  padding: 2px 4px 2px 2px;
  border: 0;
  border-radius: 999px;
  background: rgba(45, 44, 43, 0.06);
  color: #64748b;
  cursor: pointer;
}

.magic-comment-embed-name-avatar-button:hover,
.magic-comment-embed-name-avatar-button[data-expanded="true"] {
  background: rgba(255, 115, 0, 0.12);
  color: #2D2C2B;
}

.magic-comment-embed-name-avatar-image {
  width: 26px;
  height: 26px;
  border-radius: 999px;
  object-fit: cover;
  display: block;
}

.magic-comment-embed-name-avatar-chevron {
  font-size: 14px;
  line-height: 1;
  transform: translateY(-1px);
}

.magic-comment-embed-name-avatar-popover {
  position: absolute;
  right: 0;
  top: calc(100% + 8px);
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(3, 38px);
  gap: 8px;
  padding: 10px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(45, 44, 43, 0.18);
}

.magic-comment-embed-name-avatar-option {
  width: 38px;
  height: 38px;
  padding: 3px;
  border: 2px solid transparent;
  border-radius: 999px;
  background: transparent;
  cursor: pointer;
}

.magic-comment-embed-name-avatar-option:hover,
.magic-comment-embed-name-avatar-option:focus-visible {
  border-color: rgba(255, 115, 0, 0.45);
  outline: none;
}

.magic-comment-embed-name-avatar-option[data-selected="true"] {
  border-color: #ff7300;
}

.magic-comment-embed-name-avatar-option img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 999px;
  object-fit: cover;
}

.magic-comment-embed-textarea {
  min-height: 92px;
  resize: vertical;
}

.magic-comment-embed-popup-actions {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.magic-comment-embed-popup-actions-right {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 1 1 220px;
}

.magic-comment-embed-popup-button {
  border-radius: 10px;
  padding: 7px 11px;
  background: #fff3e9;
  color: #2D2C2B;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 600;
  flex: 0 0 auto;
  max-width: 100%;
}

.magic-comment-embed-popup-button[data-primary="true"] {
  background: #ff7300;
  color: #fff;
}

.magic-comment-embed-popup-button[data-danger="true"] {
  background: #dc2626;
  color: #fff;
}

.magic-comment-embed-presence-bar {
  position: fixed;
  top: 16px;
  right: 16px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 0;
  padding: 4px;
  border-radius: 999px;
  background: rgba(45, 44, 43, 0.9);
  box-shadow: 0 10px 28px rgba(45, 44, 43, 0.22);
}

/* When the FAB/toolbar is docked top-right they would overlap, so move the bar
   to the left (avatars then stack from the left edge). */
.magic-comment-embed-presence-bar[data-side="left"] {
  right: auto;
  left: 16px;
  flex-direction: row;
}

.magic-comment-embed-presence-avatar {
  appearance: none;
  border: 2px solid rgba(45, 44, 43, 0.9);
  margin-left: -8px;
  width: 30px;
  height: 30px;
  border-radius: 999px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  pointer-events: auto;
  padding: 0;
  position: relative;
  overflow: hidden;
  transition: transform 0.1s ease;
}

.magic-comment-embed-presence-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 999px;
  object-fit: cover;
  display: block;
}

.magic-comment-embed-presence-avatar:first-child {
  margin-left: 0;
}

.magic-comment-embed-presence-avatar:hover {
  transform: translateY(-2px);
  z-index: 1;
}

.magic-comment-embed-presence-avatar.magic-comment-embed-presence-avatar-self {
  border-color: #ff7300;
}

.magic-comment-embed-presence-avatar.magic-comment-embed-presence-offpage::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: #f59e0b;
  border: 2px solid rgba(45, 44, 43, 0.9);
}

.magic-comment-embed-presence-avatar.magic-comment-embed-presence-avatar-following {
  border-color: #ff7300;
  box-shadow: 0 0 0 2px #ff7300;
}

.magic-comment-embed-follow-indicator {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 7px 8px 7px 14px;
  border-radius: 999px;
  background: #ff7300;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 10px 28px rgba(255, 115, 0, 0.35);
}

.magic-comment-embed-follow-indicator-stop {
  appearance: none;
  border: 0;
  cursor: pointer;
  pointer-events: auto;
  border-radius: 999px;
  padding: 4px 10px;
  font: inherit;
  font-size: 12px;
  font-weight: 700;
  background: rgba(255, 255, 255, 0.22);
  color: #fff;
}

.magic-comment-embed-follow-indicator-stop:hover {
  background: rgba(255, 255, 255, 0.34);
}

.magic-comment-embed-cursor {
  position: fixed;
  transform: translate(-4px, -4px);
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.magic-comment-embed-cursor-pointer {
  width: 12px;
  height: 12px;
  border-radius: 999px 999px 999px 0;
  transform: rotate(-45deg);
}

.magic-comment-embed-cursor-label {
  border-radius: 999px;
  padding: 2px 8px;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
`;
